export default {"src":"/_next/static/media/ra-fill-address.1355ca5d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};